import { render, staticRenderFns } from "./RegistrationShopsTableButtons.vue?vue&type=template&id=71ebc6a2&"
import script from "./RegistrationShopsTableButtons.vue?vue&type=script&lang=js&"
export * from "./RegistrationShopsTableButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports